import {
  Checkbox,
  Typography,
  TextField,
  makeStyles,
  FormControlLabel,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { classes as workerStyles } from "../AddWorkerStyles";
import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { isEmptyObject } from "utils";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";

const useStyles = makeStyles((theme)=> workerStyles(theme));

const GorpaAccess = ({
  setIsGorpaWorker,
  setGorpaValid,
  initialValue
})=>{
  const classes = useStyles();
  const { control, setValue, getValues, errors, clearErrors}=useFormContext();
  const [gorpaRole, setGorpaRole] = useState(null);
  const [isGorpaActiveTicked, setIsGorpaActiveTicked] = useState(false);
  const {t} = useTranslation();
  const [gorpaRoles, setGorpaRoles] = useState(["Admin", "Configure", "Execute", "Read Only"]);

  useEffect(()=>{
    if(!isEmptyObject(initialValue)){
      setValue("isGorpaActive", initialValue.isActive);
      setValue("gorpaRole", initialValue.role);
      setIsGorpaActiveTicked(initialValue?.isActive);
      setGorpaRole(initialValue?.role);
    }
  },[initialValue]);

  useEffect(()=>{
    if(getValues("isGorpaActive") || initialValue?.isActive){
      setIsGorpaWorker(true);
    }
    else{
      setIsGorpaWorker(false);
    }
  },[isGorpaActiveTicked]);

  useEffect(()=>{
    console.log("GORPA ROLE", getValues("gorpaRole"));
    if(getValues("isGorpaActive")){
      if(getValues("gorpaRole")?.length === 0 ||
        getValues("gorpaRole")===null){
          setGorpaValid(false);
        }
        else{
          setGorpaValid(true);
        }
    }
    else{
      setGorpaValid(true);
    }
  },[
     getValues("isGorpaActive"),
     getValues("gorpaRole")
  ]);


  return(
    <>
      <Typography
          variant="h6"
          gutterBottom
          className={`${classes.employeeId} ${classes.title}`}
          >
            {t("other.lblGorpaUserAccess")}
      </Typography>
        <FormControlLabel
          control={
            <Controller
              name="isGorpaActive"
              control={control}
              defaultValue={isGorpaActiveTicked}
              render={(props)=>(
              <>
                <Checkbox
                    {...props}
                    checked={props.value}
                    onChange={(e)=>{
                      setIsGorpaActiveTicked(e.target.checked);
                      props.onChange(e.target.checked);
                    }}
                    color="primary"
                    style={{paddingLeft: 0}}
                    inputRef={props.ref}
                />
              </>
            )}
          />
        }
        label={t("other.lblEnableGorpaAccess")}
      />
      <Controller
            name="gorpaRole"
            control={control}
            defaultValue={gorpaRole}
            disabled={!isGorpaActiveTicked}
            rules={isGorpaActiveTicked ? {required: "Role connot be blank"} : false}
            render={(props)=>(
              <Autocomplete
                  size="small"
                  style={{marginTop: 20, marginBottom: 20}}
                  options={gorpaRoles}
                  value={props.value}
                  disableClearable
                  disabled={!isGorpaActiveTicked}
                  renderInput={(params)=>(
                    <TextField
                        {...params}
                        style={{maxWidth: 300}}
                        id="gorpaRole"
                        name="gorpaRole"
                        label={properCase(props.value? t("other.lblUserPermissions")
                      : t("other.lblSelectUserPermisions"))}
                      required={getValues("isGorpaActive")}
                      error={
                        Boolean(errors.gorpaRole) && isGorpaActiveTicked
                      }
                      helperText={errors.gorpaRole?.message}
                      />
                  )}
                  onChange={(e, val)=>{
                    props.onChange(val);
                  }}
                />
            )}
          />
    </>
  );

};

export default GorpaAccess;